<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="ew-app-main">
      <router-view/>
    </div>
    <footer class="ew-app-footer" v-if="!isDashboardRoute && !hasOwnFooter">2026 - Moovet App versión 2.0 | Gracias por Innovar con KND Technologies | <a class="ew-app-footer__link" href="https://knd.mx" target="_blank" rel="noopener noreferrer">knd.mx</a></footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    // PanelControl.vue (el shell de /dashboard y sus rutas hijas) ya pone su
    // propio footer dentro de .sw-content, respetando el margin-left del
    // sidebar — este de aquí es para todo lo demás (marketing, auth, el
    // flujo de cotización de invitados, etc.), para no duplicarlo ahí.
    isDashboardRoute () {
      return this.$route.matched.some(record => record.meta && record.meta.dashboard)
    },
    // Igual que arriba, pero para páginas públicas que ya traen su propio
    // footer con enlaces de la empresa (ownFooter:true en su ruta) — antes
    // se veían los dos apilados, el propio y encima el genérico de aquí.
    hasOwnFooter () {
      return this.$route.matched.some(record => record.meta && record.meta.ownFooter)
    }
  },
  mounted(){
  },
  beforeDestroy(){

  }
}

</script>

<style lang="scss">
@import "/assets/styles/variables";
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/dist/bootstrap-vue";
@import "/assets/styles/bootswatch";
@import "/assets/styles/app-tokens";

// `<b-modal>` transporta su contenido a un <div> agregado directo a <body>
// (ver bootstrap-vue/src/components/transporter/transporter.js, prop
// `container` default 'body'), fuera del árbol donde cada .ew-page declara
// `@include app-tokens;`. Las custom properties no heredan entre elementos
// hermanos, así que sin esto var(--app-border) etc. quedan sin resolver
// dentro de cualquier modal y las reglas que las usan (ej. border) caen a
// su valor inicial — de ahí los inputs sin marco visible dentro de modales.
body { @include app-tokens; }

.ew-offline{
  width: 15rem;
}
nav.navbar {
  font-family: "Montserrat", sans-serif;
  a {
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
}

.ew-budgeter-form {
  background: white;
  padding: 0.25rem;
}

.ew-budgeter-form .form-group {
  margin-bottom: 0;
  margin-right: 0.25rem;
}

.ew-budgeter-form .form-group:last-child {
  margin-right: 0;
}

.ew-clean-btn {
  border: 1px solid transparent;
  background: transparent;
  margin-bottom: 0.3rem;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }

  img {
    width: 2.5rem;
  }
}

.ew-features-section h3 {
  font-family: "Montserrat", sans-serif;
  margin-bottom: 3rem;
  margin-top: 5rem;
  font-weight: 700;
}

.ew-feature-card {
  color: #fff;
  font-family: "Montserrat", sans-serif;
  padding: 1rem;

  h4 {
    font-size: 1rem;
    font-weight: 600;
  }

  img {
    max-width: 7rem;
  }
}

.ew-footer {
  font-family: "Montserrat", sans-serif;
  padding: 2rem;
  margin-top: 8rem;
  font-weight: 400;

  h4 {
    font-size: 17px;
    letter-spacing: 0px;
    line-height: 32px;
    margin-bottom: 0px;
    color: #073258;
    font-family: "Montserrat";
    font-weight: 800;
  }
}

.ew-footer--primary {
  padding-top: 8%; 
  color: #073258;
  background-image:  url("./assets/images/footer-02.svg");
  background-size: 100% auto;
  background-position: center bottom;
  background-size: 100%;
  background-repeat: no-repeat;
}

.ew-footer a {
  color: #073258;
  font-weight:bold;
  font-size: 14px;
  letter-spacing: 0px;
  line-height: 20px;
  color: #073258;
  font-family: "Montserrat";
  font-weight: 500;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
}

.ew-footer a:hover {
  color: #fff;
  text-decoration: underline;
}

.ew-footer ul {
  list-style: none;
}

.ew-border-left{
  position: relative;
  &::before{
    display: block;
    content:"";
    position:absolute;
    border-left: 3px solid #ffffff;
    height: 100%;
    left: 0;

  }
}

@media (max-width: 600px) {
  .ew-border-left{
  position: relative;
  &::before{
    display: none;
    content:"";
    position:absolute;
    border-left: 3px solid #ffffff;
    height: 100%;
    left: 0;

  }
}
}

.ew-footer ul li:last-child {
  margin-bottom: 0;
}

.ew-form {
  max-width: 400px;
  margin: 0 auto;
}

.ew-home-jumbotron {
  position: relative;
  background-color: #d1d1d1;
  background-image: url("./assets/images/fondo.jpg");
  min-height: 40vmax;

  padding-bottom: 15rem;
  background-repeat: no-repeat;
}

.ew-home-jumbotron h2 {
  font-size: 2.25rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  margin: 1em;
}

.ew-home-jumbotron label {
  font-family: "Montserrat", sans-serif;
  color: $primary;
}

.ew-icon:hover {
  display: inline-block;
  text-decoration: none;
  transform: scale(1.1);
}

.ew-icon img {
  height: 2rem;
}

.ew-navbar-icon {
  display: inline-block;
  height: 1.5rem;
  width: 1.5rem;

  &-sm {
    height: 1rem;
    width: 1rem;
  }
}

// Nota: las clases .ew-login-* que vivían aquí (layout viejo de
// SignIn/SignUp/PasswordRecovery/ChangePassword) se quitaron al rediseñar
// esas 4 pantallas — ahora cada una trae su propio estilo scoped
// (mixins ew-auth-* en _ew-components.scss), no hay nada más que las use.

.ew-navbar {
  border-bottom: 2px solid $primary;
}

.ew-navbar-dropdown {
  .dropdown-toggle,
  .btn {
    padding: 0;

    img {
      max-height: 2rem;
    }
  }
}

.ew-navbar-logo {
  height: 2.8rem;
}

.ew-service-provider-filter {
  margin-bottom: 1.25rem;
}

.ew-service-provider-filter:last-child {
  margin-bottom: 0;
}

.ew-service-provider-filter .ew-filter-heading {
  color: $primary;
  line-height: 100%;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.ew-service-provider-filter .ew-filter-body {
  margin-left: 1rem;
}

.ew-shipment-option-card {
  background-color: #fff;
  border: 1px solid #bababa;
  padding: 1rem;
  &:hover {
    background-color: transparentize($primary, 0.95);
  }

  .small-text {
    font-size: 0.8em;
  }
}
.ew-datails-option-shipment{
    cursor: pointer;
    font-size: 0.6
}

.ew-shipment-option-card--price {
  color: $primary;
  font-size: 1.2rem;
  text-align: right;

  p{
    text-align: right;
  }
}

.ew-smaller-container {
  max-width: 1000px;
  margin: 0 auto;
}

.ew-section-header {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  border-bottom: 1px solid #bababa;
  margin-bottom: 1.75rem;
  margin-top: 4rem;
  padding-bottom: 1rem;

  &--no-margin {
    margin-top: 0;
  }
}

.ew-tabs {
  border-bottom: 1px solid $gray-500;
  // margin-bottom: 3rem;
}

.ew-bg-gray {
  background-color: #f3f3f3;
  //background-color: red;
}

.no-radius-left {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.no-radius-right {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.no-padding {
  padding: 0;
}

.no-grow {
  flex-grow: 0;
}

.alt-font {
  font-family: $font-family-sans-serif-heading;
}

.ew-bigger-line-height {
  line-height: 2;
}

// List Utilities
.ew-list-roman-styles {
  counter-reset: list;

  & > li {
    list-style: none;
    position: relative;
  }
  & > li:before {
    counter-increment: list;
    content: counter(list, upper-roman) ". ";
    font-weight: bold;
    position: absolute;
    left: -1.4em;
  }
}

.ew-list-latin-styles {
  counter-reset: list;

  & > li {
    list-style: none;
    position: relative;
  }
  & > li:before {
    counter-increment: list;
    content: counter(list, lower-alpha) ") ";
    position: absolute;
    left: -1.4em;
  }
}
#app{
    overflow-x: hidden;
}
.ew-text-warranty{
  font-size: 14px
}
.txt-f1{
    margin-top: 10px;
}
.pdn-l1{
    text-align: left;
    font-weight:bold;
}

@media (max-width: 852px) {
  .ew-smaller-container {
    max-width: 100%;
    padding: 0px 15px;
  }
}

@media (max-width: 991px) {
  .ew-navbar-icon {
    height: 1.2rem;
    width: 1.2rem;
  }
}
@media (max-width: 768px) {
 .title-2{
    font-size: 1.1rem;
    margin-bottom: 30px;
    margin-top: 0!important;
}
}
@media (max-width: 767px) {

  .navbar-nav{
    margin-top: 20px;
  }
  .ew-navbar-icon {
    display: none;
  }
  .pl1{
    padding-left: 40px;
  }
  select[data-v-2dcb1cf7] {
      font-size: 0.7rem;
  }
  footer .ew-icon img {
    height: 3rem;
  }
  .input-group[data-v-9ddb17c0]{
    margin-bottom: 15px;
  }
  .pdn-l1{
    padding-left: 46px;
  }
}

@media (max-width: 575px) {
  footer ul,.pl1{
   padding:0px;
  }
  .pdn-l1 {
    padding-left: 6px;
  }
}
@media (max-width: 425px) {
  select[data-v-2dcb1cf7] {
    font-size: 0.9375rem;
  }
  .ew-loading-indicator .inner-container{
    overflow-x: hidden;
    width: 100%;
  }
  .align-self-center.inner-container img{
    width: 300px;
    height: 300px;
  }
  .title-2,.ew-loading-indicator .font-weight-bold {
    font-size: 1rem;
    padding: 0px 15px;
  }
}

.ew-smaller-container-quoting {
  max-width: 1000px;
  margin: 0 auto;
}

@media (max-width: 852px) {
  .ew-smaller-container-quoting {
    max-width: 100%;
    padding: 0px 15px;
  }
}

.ew-area-remote{
  color: $primary;
}

.ew-table-datails{
  .table th, .table td{
    padding: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem
  }
}

.ew-white{
  background-color: #ffffff;
}

.ew-height{
 height: 100%;
}

.ew-box-shadow{
   box-shadow: 0 0 4px 0 rgba(0,0,0,0.16);
}
#app{
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.ew-app-main { flex: 1 0 auto; }
.ew-app-footer {
  flex-shrink: 0;
  padding: 1.1rem 1rem;
  border-top: 1px solid #e2e8ee;
  background: #fff;
  font-family: "Montserrat", "Segoe UI", Arial, sans-serif;
  font-size: 0.75rem;
  color: #8a97a3;
  text-align: center;
}
.ew-app-footer__link {
  color: inherit;
  text-decoration: none;
  &:hover { color: #073258; text-decoration: underline; }
}
.ew-section-header-edit {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;

  padding-bottom: 1rem;

  &--no-margin {
    margin-top: 0;
  }
}
.ew-border-radius{
  border-radius: 2px
}
.ew-font-size--popovers{
  font-size: 0.72rem
}


.ew-cursor{
  cursor: pointer;
}

.ew-conten-payment{
    padding: 1.8rem;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.16);

}
.ew-imag-payment{
  max-width: 94px;
  margin-top: -79px;
}

.ew-mar-none{
  margin-top: 0
}

.ew-custom-dropdown-navbar{
  .dropdown-menu {
    background-color: #f6f7f7;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.16);
    border-radius: 0px;
    border: none;

  }
  .dropdown-menu::after {
    content: '';
    display: inline-block;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #f6f7f7; /* change color here, modified for a black arrow */
    position: absolute;
    top: -10px;
    left: 90%;
  }
}

.ew-custom-dropdown-navbar{
  .ew-help-dropdown{
  .dropdown-menu {
    background-color: #f6f7f7;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.16);
    border-radius: 0px;
    border: none;

  }
  .dropdown-menu::after {
    content: '';
    display: inline-block;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #f6f7f7; /* change color here, modified for a black arrow */
    position: absolute;
    top: -10px;
    left: 5%;
  }
  }
}

.ew-radio-image{
  width: 75px;
}

.ew-custom-control-label{
  margin-left: 0.5rem
}

.ew-from-control--input{
  border: 1px solid #ced4da;
}

.ew-from-control--input-primary{
  border: 1px solid $primary;
}

/*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 100;
  src: url('./assets/fonts/montserrat/montserrat-v12-latin-100.eot'); /* IE9 Compat Modes */
  src: local('Montserrat Thin'), local('Montserrat-Thin'),
       url('./assets/fonts/montserrat/montserrat-v12-latin-100.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/montserrat/montserrat-v12-latin-100.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-100.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-100.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/montserrat/montserrat-v12-latin-100.svg#Montserrat') format('svg'); /* Legacy iOS */
}
/* montserrat-200 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 200;
  src: url('./assets/fonts/montserrat/montserrat-v12-latin-200.eot'); /* IE9 Compat Modes */
  src: local('Montserrat ExtraLight'), local('Montserrat-ExtraLight'),
       url('./assets/fonts/montserrat/montserrat-v12-latin-200.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/montserrat/montserrat-v12-latin-200.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-200.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-200.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/montserrat/montserrat-v12-latin-200.svg#Montserrat') format('svg'); /* Legacy iOS */
}
/* montserrat-300 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 300;
  src: url('./assets/fonts/montserrat/montserrat-v12-latin-300.eot'); /* IE9 Compat Modes */
  src: local('Montserrat Light'), local('Montserrat-Light'),
       url('./assets/fonts/montserrat/montserrat-v12-latin-300.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/montserrat/montserrat-v12-latin-300.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-300.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-300.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/montserrat/montserrat-v12-latin-300.svg#Montserrat') format('svg'); /* Legacy iOS */
}
/* montserrat-regular - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/montserrat/montserrat-v12-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Montserrat Regular'), local('Montserrat-Regular'),
       url('./assets/fonts/montserrat/montserrat-v12-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/montserrat/montserrat-v12-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/montserrat/montserrat-v12-latin-regular.svg#Montserrat') format('svg'); /* Legacy iOS */
}
/* montserrat-500 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  src: url('./assets/fonts/montserrat/montserrat-v12-latin-500.eot'); /* IE9 Compat Modes */
  src: local('Montserrat Medium'), local('Montserrat-Medium'),
       url('./assets/fonts/montserrat/montserrat-v12-latin-500.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/montserrat/montserrat-v12-latin-500.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-500.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-500.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/montserrat/montserrat-v12-latin-500.svg#Montserrat') format('svg'); /* Legacy iOS */
}
/* montserrat-600 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  src: url('./assets/fonts/montserrat/montserrat-v12-latin-600.eot'); /* IE9 Compat Modes */
  src: local('Montserrat SemiBold'), local('Montserrat-SemiBold'),
       url('./assets/fonts/montserrat/montserrat-v12-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./assets/fonts/montserrat/montserrat-v12-latin-600.woff2') format('woff2'), /* Super Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-600.woff') format('woff'), /* Modern Browsers */
       url('./assets/fonts/montserrat/montserrat-v12-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./assets/fonts/montserrat/montserrat-v12-latin-600.svg#Montserrat') format('svg'); /* Legacy iOS */
}

.ew-profile-header{
  margin-top: 0.5rem;
  margin-bottom: 2rem;
}

.ew-cursor-pointer{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue